/* eslint-disable */

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const formatDateRange = (startDate, endDate) => {
  const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
  const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

  const startMonthName = MONTHS[startMonth - 1];
  const endMonthName = MONTHS[endMonth - 1];

  if (startYear === endYear) {
    if (startMonth === endMonth) {
      return `${startMonthName} ${startDay} - ${endDay}, ${endYear}`;
    } else {
      return `${startMonthName} ${startDay} - ${endMonthName} ${endDay}, ${endYear}`;
    }
  } else {
    return `${startMonthName} ${startDay}, ${startYear} - ${endMonthName} ${endDay}, ${endYear}`;
  }
};
